import { useState } from 'react';
import { X, ShieldCheck, Loader2 } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

export default function QuickDonateModal({ open, onClose, projectTitle, projectSlug }) {
  const [amount, setAmount] = useState(25);
  const [donating, setDonating] = useState(false);
  const [done, setDone] = useState(false);

  if (!open) return null;

  const handleDonate = () => {
    setDonating(true);
    setTimeout(() => {
      setDonating(false);
      setDone(true);
      setTimeout(() => { setDone(false); onClose(); }, 2000);
    }, 1200);
  };

  const txHash = '0x' + Array.from({ length: 64 }, () => Math.floor(Math.random() * 16).toString(16)).join('');

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/40" onClick={onClose}>
        <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="w-full max-w-xs bg-white rounded-xl shadow-2xl" onClick={e => e.stopPropagation()} data-testid="quick-donate-modal">
          {done ? (
            <div className="p-6 text-center">
              <div className="w-12 h-12 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-3"><ShieldCheck className="w-6 h-6 text-emerald-600" /></div>
              <p className="font-semibold text-slate-900 mb-1">Donated!</p>
              <p className="text-xs text-slate-400 mb-2">${amount} to {projectTitle || 'Project'}</p>
              <div className="flex items-center justify-center gap-1 text-[10px] text-emerald-600 font-medium">
                <ShieldCheck className="w-3 h-3" /> Glass Box Verified
              </div>
              <p className="text-[10px] text-slate-300 font-mono mt-1 truncate">{txHash.slice(0, 20)}...</p>
            </div>
          ) : (
            <>
              <div className="flex items-center justify-between px-4 py-3 border-b border-slate-100">
                <h3 className="font-semibold text-sm text-slate-900">Quick Donate</h3>
                <button onClick={onClose} className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-slate-100"><X className="w-4 h-4 text-slate-400" /></button>
              </div>
              <div className="p-4 space-y-3">
                <p className="text-xs text-slate-500 truncate">{projectTitle || 'This project'}</p>
                <div className="grid grid-cols-4 gap-2">
                  {[10, 25, 50, 100].map(a => (
                    <button key={a} onClick={() => setAmount(a)} className={`py-2 rounded-lg text-sm font-semibold transition-colors ${amount === a ? 'bg-[#7C3AED] text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`} data-testid={`amount-${a}`}>
                      ${a}
                    </button>
                  ))}
                </div>
                <button onClick={handleDonate} disabled={donating} className="w-full py-2.5 rounded-lg bg-gradient-to-r from-[#7C3AED] to-[#2563EB] text-white text-sm font-semibold hover:shadow-lg transition-all disabled:opacity-50" data-testid="donate-submit">
                  {donating ? <Loader2 className="w-4 h-4 animate-spin mx-auto" /> : `Donate $${amount}`}
                </button>
              </div>
            </>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
